import React from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { ExternalUpdateTitle } from '../../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/ExternalUpdateTitle'
import { SyncStatusView } from '../../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/models'
import { IntegrationIcon } from '../../IntegrationIcon'

interface IntegrationSavedHistoryEntryProps {
  syncStatus: SyncStatusView
}

const defaultCheckMarkColor = 'green'

export const IntegrationSavedHistoryEntry: React.FC<IntegrationSavedHistoryEntryProps> = ({ syncStatus }) => {
  return (
    <div className='d-flex align-items-center gap-3 px-3'>
      <IntegrationIcon serviceId={syncStatus.serviceId as IntegrationServiceId} className={'crm-icon'} />
      <ExternalUpdateTitle syncStatus={syncStatus} />
      <i className='bi bi-check-lg ms-auto' style={{ color: defaultCheckMarkColor }} />
    </div>
  )
}
